<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5 class="mb-20 mt-3">Chercher les numéros de téléphone :</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div class="col-12">
          <div
            v-if="error_blacklst.msg == 'not exist'"
            class="alert alert-success mb-0"
            role="alert"
          >
            <i class="bi bi-exclamation-circle me-2"></i>
            Ce numéro de téléphone est sûr
          </div>
          <div
            v-if="error_blacklst.msg == 'exist'"
            class="alert alert-danger mb-0"
            role="alert"
          >
            <i class="bi bi-check-circle me-2"></i>
            Ce numéro est dans la black liste ({{ error_blacklst.count }} Colis
            Retournés.)
          </div>
        </div>
        <div class="col-md-12 mt-3">
          <div class="mb-3">
            <label for="phoneInput" class="form-label">Téléphone :</label>
            <input
              id="phoneInput"
              type="text"
              class="form-control"
              v-model="phone"
              :class="{ 'is-invalid': phoneError }"
              placeholder="Téléphone"
            />
            <div v-if="phoneError" class="invalid-feedback">
              {{ phoneError }}
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-primary "
            style="float: right;"
            @click="checkPhone"
            :disabled="invalid"
          >
            Chercher
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { Modal } from "bootstrap";
import moment from "moment";
import { onMounted, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";

export default {
  name: "BlackListeContent",
  setup: () => {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const isLoader = ref(false);
    const phone = ref("");
    const show = ref(false);
    const error_blacklst = reactive({ msg: "", statut: "", count: "" });

    const phoneError = ref("");
    const invalid = ref(false);

    async function checkPhone() {
      phoneError.value = "";
      invalid.value = false;

      // Simple validation
      if (!phone.value) {
      phoneError.value = "Le numéro de téléphone est requis.";
      invalid.value = true;
      return;
      }

      isLoader.value = true;
      try {
      const res = await api.post(`/api/auth/client/blackList?phone=${phone.value}`);
      isLoader.value = false;
      if (res.data.msg !== "no perms") {
        show.value = true;
        error_blacklst.msg = res.data.msg;
        error_blacklst.statut = res.data.statut;
        error_blacklst.count = res.data.count;
      }
      } catch (error) {
      isLoader.value = false;
      showToast("Une erreur s'est produite, veuillez réessayer.", "error");
      }
    }
    return {
      auth,
      isLoader,
      phone,
      show,
      error_blacklst,
      phoneError,
      invalid,
      checkPhone,
      user,
    };
    
  },
};
</script>